<ng-container *ngIf="templates && viewModel$ | async as viewModel">

    <p-dialog
        [modal]="true"
        [visible]="viewModel.visible"
        [closable]="false"
        [style]="{width: '50vw'}"
        [breakpoints]="{'992px': '62vw', '510px': '93vw'}"
    >
        <ng-template pTemplate="header">
            <div class="p-grid p-align-center mutate-object-header">
                <div class="p-col-2"></div>
                <div class="p-col-8 p-text-center">
                    <span
                    class="mutate-object-header-text"
                    >{{viewModel.title}}</span>
                </div>
                <div class="p-col-2 p-text-center">
                    <button
                        pButton
                        icon="pi pi-times"
                        class="p-button-text p-button-lg"
                        data-cy="close-button"
                        (click)="store.dispatch(actions.exitMutateObjectDialogButtonClicked())"
                    ></button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="footer"></ng-template>


        <div *ngIf="viewModel.currentStep && !viewModel.isReviewStep" class="content-area" style="overflow-y: auto;">
            <div class="section-header">
                <div class="p-grid p-ai-center">
                    <div class="p-col">
                        <h5 class="no-margin">{{viewModel.currentStep.name}}</h5>
                    </div>
                </div>
            </div>
            <div>
                <ng-container *ngTemplateOutlet="templates[viewModel.currentStep.templateId]"></ng-container>
            </div>
        </div>

        <div *ngIf="viewModel.isReviewStep" class="content-area">
            <p-listbox
                [options]="viewModel.steps"
                optionLabel="name"
                (onClick)="$event.option.templateId && store.dispatch(actions.reviewListboxItemClicked({
                    step: $event.option.name
                }))"
                [scrollHeight]="scrollHeight"
            >
                <ng-template
                    let-step
                    pTemplate="item"
                >
                    <div
                        class="full-width custom-listbox-item"
                        [class.disabled-review-step]="!step.templateId"
                        [class.invalid-review-step]="step.invalid"
                    >
                        <div class="p-grid p-align-center">
                            <div class="p-col p-text-left counter-grid-spacing">
                                {{step.name}}
                            </div>
                            <div class="p-col p-text-right counter-grid-spacing">
                                <span>
                                    {{ step.reviewValue }}
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-listbox>
            <br>
            <div *ngIf="disclaimer">
                <p>{{disclaimer}}</p>
            </div>
            <div *ngIf="mutateType==='update'">
                <p-checkbox
                    [binary]="true"
                    label="Only show items that can be edited"
                    [(ngModel)]="onlyShowEditableItems"
                ></p-checkbox>
            </div>
        </div>

        <div class="section-footer">

            <div class="p-grid p-align-center" *ngIf="viewModel.footerButtons === 'navigate'">
                <div class="p-col p-text-left">
                    <button
                        pButton
                        label="Prev"
                        class="navigation-button"
                        (click)="store.dispatch(actions.previousButtonClicked({ step: viewModel.previousStep.name }))"
                        [disabled]="!viewModel.previousStep"
                        icon="pi pi-arrow-left"
                    ></button>
                </div>
                <div class="p-col p-text-right">
                    <button
                        pButton
                        label="Next"
                        class="navigation-button"
                        (click)="store.dispatch(actions.nextButtonClicked({ step: viewModel.nextStep.name }))"
                        [class.hide]="!viewModel.nextStep"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        data-cy="next-button"
                    ></button>
                    <button
                        pButton
                        label="Review"
                        class="navigation-button"
                        (click)="store.dispatch(actions.reviewButtonClicked())"
                        [class.hide]="viewModel.nextStep"
                        icon="pi pi-bars"
                        data-cy="review-button"
                    ></button>
                </div>
            </div>

            <div
                class="p-grid"
                *ngIf="viewModel.footerButtons !== 'navigate'"
            >
                <div class="p-col p-text-center">
                    <button
                        *ngIf="viewModel.footerButtons === 'review'"
                        pButton
                        label="Review Changes"
                        class="navigation-button"
                        [disabled]="viewModel.currentStep?.invalid"
                        (click)="store.dispatch(actions.reviewButtonClicked())"
                        icon="pi pi-bars"
                        data-cy="review-changes-button"
                    ></button>
                    <button
                        *ngIf="viewModel.footerButtons === 'mutate'"
                        pButton
                        [label]="viewModel.loading? 'Saving...':reviewButtonText ? reviewButtonText : viewModel.mutateType | titlecase"
                        class="navigation-button p-button-success"
                        [disabled]="viewModel.invalid || viewModel.loading"
                        (click)="store.dispatch(actions.mutateButtonClicked())"
                        icon="pi pi-plus"
                    >
                    <i *ngIf="viewModel.loading" class="pi pi-spin pi-spinner" style="position: absolute; right:35%" ></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="indicator-container p-grid">
            <div
                class="p-col p-text-center"
            >
                <ng-container *ngFor="let step of viewModel.steps">
                    <span
                        *ngIf="step.editable"
                        [pTooltip]="step.name"
                        tooltipPosition="bottom"
                        [class.active-indicator]="step.name === viewModel.activeStep"
                        (click)="store.dispatch(actions.pageIndicatorClicked({ step: step.name }))"
                        class="indicator"
                    ></span>
                </ng-container>
            </div>
        </div>

    </p-dialog>

    <p-confirmDialog
        [style]="{width: '50vw'}"
        [breakpoints]="{'992px': '62vw', '510px': '93vw'}" 
    ></p-confirmDialog>

</ng-container>
